import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {

  private currentVersion = '';

  constructor(
    private http: HttpClient
  ) {
    this.loadVersion();
  }

  loadVersion(): void {

    this.http
      .get<any>('assets/version.json')
      .subscribe({

        next: (response) => {

          this.currentVersion =
            response.version;

          console.log(
            'Current Version:',
            this.currentVersion
          );

        },

        error: (error) => {

          console.error(
            'Version Load Error',
            error
          );

        }

      });

  }

  checkVersion(): void {

    this.http
      .get<any>(
        'assets/version.json?t=' +
        new Date().getTime()
      )
      .subscribe({

        next: (response) => {

          if (
            this.currentVersion &&
            this.currentVersion !== response.version
          ) {

            console.log(
              'New Version Available'
            );

            window.location.reload();

          }

        },

        error: (error) => {

          console.error(
            'Version Check Error',
            error
          );

        }

      });

  }

}